import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-production-menu',
    templateUrl: './production-menu.component.html',
    styleUrls: ['./production-menu.component.css'],
})
export class ProductionMenuComponent {
    /**
     * The name of the production webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
